import { render, staticRenderFns } from "./GuestListItemActionSelector.vue?vue&type=template&id=2072608c&scoped=true&"
import script from "./GuestListItemActionSelector.vue?vue&type=script&lang=js&"
export * from "./GuestListItemActionSelector.vue?vue&type=script&lang=js&"
import style0 from "./GuestListItemActionSelector.vue?vue&type=style&index=0&id=2072608c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072608c",
  null
  
)

export default component.exports